// APEXCHARTS LANGUAGE CHANGE

// Locale/weekday related imports
import fi from "apexcharts/dist/locales/fi.json"
import se from "apexcharts/dist/locales/se.json"
import en from "apexcharts/dist/locales/en.json"

const localesApexChart = [fi, en, se]

const initLanguage = () => {
  const currentLanguage = localStorage.getItem("i18nextLng")
  if (currentLanguage) {
    if (currentLanguage.startsWith("fi")) {
      return "fi"
    } else if (currentLanguage.startsWith("sv")) {
      return "se"
    } else {
      return "en"
    }
  }
}
const stateLanguage = (id, lang) => {
  switch (lang) {
    case "fi":
      ApexCharts.exec(id, "setLocale", "fi")
      return "fi"
    case "en":
      ApexCharts.exec(id, "setLocale", "en")
      return "en"
    case "sv":
      ApexCharts.exec(id, "setLocale", "se")
      return "se"
  }
}

export { localesApexChart, initLanguage, stateLanguage }
